module.exports = __webpack_public_path__ + "img/8F7B61_D6B892_4E4436_C3AC86-256px.65efd144.png";